import { render, staticRenderFns } from "./ToTopButton.vue?vue&type=template&id=010a4fbe&scoped=true"
import script from "./ToTopButton.vue?vue&type=script&lang=js"
export * from "./ToTopButton.vue?vue&type=script&lang=js"
import style0 from "./ToTopButton.vue?vue&type=style&index=0&id=010a4fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a4fbe",
  null
  
)

export default component.exports